import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { USER_IDP_GROUPS_COLUMN_ID } from "../constants";
import UserIdpGroupsListItemNameCell from "./NameCell";
import { IdpGroupWithMapped } from "../types";
import UserIdpGroupsListItemStatusCell from "./StatusCell";
import UserIdpGroupsListItemDescriptionCell from "./DescriptionCell";

const CELLS = {
  [USER_IDP_GROUPS_COLUMN_ID.NAME]: UserIdpGroupsListItemNameCell,
  [USER_IDP_GROUPS_COLUMN_ID.DESCRIPTION]: UserIdpGroupsListItemDescriptionCell,
  [USER_IDP_GROUPS_COLUMN_ID.STATUS]: UserIdpGroupsListItemStatusCell,
};

type UserIdpGroupsListItemProps = {
  group: IdpGroupWithMapped;
};

const UserIdpGroupsListItem = (props: UserIdpGroupsListItemProps) => {
  const { group } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as USER_IDP_GROUPS_COLUMN_ID];
        const uniqueKey = `${id}-${group.name}`;

        const childrenComponent = <Component name={group.name} mappedGroup={group.mapped} />;

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(UserIdpGroupsListItem);
